import { graphql } from 'app/generated/gql'

/** Both operations are sent through a raw fetch rather than the urql client, so the hook prints them. */
export const OPS_RECONCILE_CANDIDATES_QUERY = graphql(`
  query OpsReconcileCandidates($search: String, $pagination: PaginationInput) {
    contacts(search: $search, pagination: $pagination) {
      hits {
        id
        name
        patientStatus
        appointmentStatus
        hygieneDueDate
        nearestAppointmentDate
        birthDate
        isPerio
        unbookedTreatmentValue
        pipelines {
          id
          stage
        }
      }
    }
  }
`)

export const OPS_RECONCILE_ADD_MUTATION = graphql(`
  mutation OpsReconcileAddToPipeline($id: ID!, $pipeline: ContactPipelineInput!) {
    addToPipeline(id: $id, pipeline: $pipeline) {
      id
    }
  }
`)
